import TekoID, { IUserDetailsInfo, IUserInfo } from 'teko-oauth2';
import { browserHistory } from 'helpers';
import { NullAble } from 'data/base';

// In user service, we need to check whether TekoID.user is not null before using because
// we only initialize TekoID when there is auth config from MM

const isLoggedIn = (): boolean => {
  return TekoID.user && TekoID.user.isLoggedIn();
};

const logout = (redirectUrl?: string) => {
  // Tracking - Reset userId when logged out
  track('resetUserId');

  if (TekoID.user == null) {
    return;
  }

  TekoID.user.logout(redirectUrl);
};

const getAccessToken = (): string => {
  if (TekoID.user == null) {
    return '';
  }

  return TekoID.user.getAccessToken();
};

const getUserInfo = (): NullAble<IUserInfo> => {
  if (TekoID.user == null) {
    return null;
  }

  return TekoID.user.getUserInfo();
};

const getFullUserInfo = async (): Promise<NullAble<IUserDetailsInfo>> => {
  if (TekoID.user == null) {
    return null;
  }

  const fullUserInfo = await TekoID.user.getFullUserInfo();
  return fullUserInfo;
};

const denyAccess = () => {
  browserHistory.push('/403');
};

export default {
  isLoggedIn,
  logout,
  getAccessToken,
  getUserInfo,
  getFullUserInfo,
  denyAccess,
};
